export enum InputSize {
  Large = '54px',
  Medium = '48px'
}
